export default __webpack_public_path__ + "static/media/vitalik_banner.c2203726.jpeg";